import { ReconnectRequestEvent } from '@/social/account/action/reconnect';
import { ReconnectRequest } from '@/social/types';
import api from '@/social/API';
import eventBus from '@/messaging/event-bus';

export class PostImportSupportRequested extends ReconnectRequestEvent {
  static eventName = 'import_support_requested';
}

export function requestSupport(accountId: number): Promise<ReconnectRequest> {
  return api
    .put(`/accounts/${accountId}/request-post-import-support`)
    .then((response) => {
      const request = response.data;
      eventBus.$emit(PostImportSupportRequested.eventName, new PostImportSupportRequested(request));
      return request;
    });
}
